import styled from '@emotion/styled';

export const LogInLink = styled.span`
  font-family: Inter;
  font-style: Medium;
  text-align: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  color: #5e84ed;
  font-size: 14px;
  font-weight: 600;
  word-wrap: break-word;
`;

export const AlreadyHaveAccount = styled.span`
  text-align: center;
  color: #b7bdcb;
  font-size: 14px;
  font-family: Montserrat;
  font-weight: 400;
  word-wrap: break-word;
`;

export const EnterInvitationCode = styled.span`
  display: flex;
  justify-content: center;
  color: #e9ecf5;
  font-size: 14px;
  font-family: Montserrat;
  font-weight: 500;
  word-wrap: break-word;
  text-align: center;
`;

export const LoginSection = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 48px;
`;

export const RequestInvitation = styled.span`
  opacity: 0.8;
  text-align: center;
  color: #5e84ed;
  font-size: 14px;
  font-family: Montserrat;
  font-weight: 600;
  word-wrap: break-word;
  cursor: pointer;
`;
